module.exports = __webpack_public_path__ + "static/media/asignatura5.8422fe31.png";